import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import gitSearch from "../../Assets/Projects/github search.png";
import wiki from "../../Assets/Projects/wiki.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={gitSearch}
              isBlog={false}
              title="The trailer of movies website"
              description="Full stack app with subscription plan. The customer can log in and register on the app, but without a checkout plan, they cannot take full advantage of our platform. We have used every protected page. After registration, the user must buy one plan out of three. We have integrated payment with stripe. Firebase to authenticate and save some user data. The customer can also change or cancel the subscription and manage payment details."
              ghLink="https://github.com/M-Orziboyev"
              demoLink="https://m-orziboyev.github.io/Search-github-users/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={wiki}
              isBlog={false}
              title="Wikipedia API"
              description="This is API Project"
              ghLink=""
              demoLink="https://m-orziboyev.github.io/wikipedia-api/"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
